import { render, staticRenderFns } from "./SentimentChart.vue?vue&type=template&id=33cb3986&"
import script from "./SentimentChart.vue?vue&type=script&lang=js&"
export * from "./SentimentChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports